import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import CommonBanner from '../common/Banner';

const ItConnects: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('ItConnects');
    return (
        <div id="ItConnects GtmModuleData-section" data-section-id="ItConnects">
            <CommonBanner
                title={t('title')}
                pc="https://websiteoss.ecoflow.com/upload/image/1753683384481/pc.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1753683384715/pad.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1753683384973/h5.jpg"
            />
        </div>
    );
};

export default ItConnects;
